module.exports = __webpack_public_path__ + "img/4-(2).932ee7ef.jpg";